import { auth } from "../../config/firebaseConfig";
import { AUTH_ERROR, RESTAURANT_CONFIG, SIGN_IN, SIGN_OUT } from "../types/auth";
import { signOut } from "firebase/auth";
import { setnotification } from "./styles";

export const signIn = (data) => async (dispatch) => {
  const { user, userData } = data;

  dispatch({ type: SIGN_IN, payload: { user, userData } });
};

export const logOut = () => async (dispatch) => {
  await signOut(auth);
  dispatch({ type: SIGN_OUT });
};
